import { connect } from 'react-redux'
import { IStore } from '../../../../reducers'
import { isLicenseValid } from '../../../../reducers/userAccount/selectors/license'
import openModal from '../../../../actions/Modals/openModal'
import closeModal from '../../../../actions/Modals/closeModal'

const mapStateToProps = (state: IStore) => ({
  isPremium: isLicenseValid(state),
})

const mapDispatchToProps = dispatch => ({
  modalClose: id => dispatch(closeModal(id)),
  modalOpen: (id, element) => dispatch(openModal(id, element)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)
